"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAvailable = void 0;
let _ampContext = -1;
function findAmpContext() {
    const findAmpContext_ = (windowObject) => {
        const contextObject = windowObject.context;
        if (contextObject && contextObject.observeIntersection) {
            return contextObject;
        }
        else if (windowObject === window.top) {
            return null;
        }
        else {
            return findAmpContext_(windowObject.parent);
        }
    };
    if (typeof window !== 'undefined') {
        try {
            return findAmpContext_(window);
        }
        catch (ignored) { }
    }
    return null;
}
function isAvailable() {
    if (_ampContext === -1) {
        _ampContext = findAmpContext();
    }
    return _ampContext !== -1 && !!_ampContext;
}
exports.isAvailable = isAvailable;
//# sourceMappingURL=amp-pixel.js.map